import consumer from "./consumer"

/**
 * Sistema de notificações em tempo real para chat rooms
 * Conecta ao ActionCable e gerencia indicadores visuais de novas mensagens
 */
export function initChatNotifications() {
  console.log("💬 [CHAT NOTIFICATIONS] Iniciando sistema de notificações de chat...");

  // Previne múltiplas inicializações
  if (window.App && window.App.chatNotifications) {
    console.log("💬 [CHAT NOTIFICATIONS] Canal já ativo, removendo conexão anterior...");
    // Remove o canal anterior antes de criar novo
    window.App.chatNotifications.unsubscribe();
    delete window.App.chatNotifications;
  }

  // Verifica se o usuário está logado
  const currentUserId = document.body.dataset.currentUserId;
  if (!currentUserId) {
    console.warn("💬 [CHAT NOTIFICATIONS] Usuário não logado - canal não será inicializado");
    return;
  }

  // Inicializa namespace global se não existir
  if (!window.App) window.App = {};

  const channelName = `chat_notifications_${currentUserId}`;
  console.log(`💬 [CHAT NOTIFICATIONS] Conectando usuário ${currentUserId} ao canal: ${channelName}`);

  try {
    // Cria a subscription do ActionCable
    window.App.chatNotifications = consumer.subscriptions.create(
      { channel: "ChatNotificationsChannel::Channel" },
      {
        connected() {
          console.log("✅ [CHAT NOTIFICATIONS] Canal conectado com sucesso");
          console.log(`✅ [CHAT NOTIFICATIONS] Escutando canal: chat_notifications_${currentUserId}`);
        },

        disconnected() {
          console.warn("❌ [CHAT NOTIFICATIONS] Canal desconectado");
        },

        rejected() {
          console.error("🚫 [CHAT NOTIFICATIONS] Conexão rejeitada pelo servidor");
        },

        received(data) {
          console.log("📨 [CHAT NOTIFICATIONS] Nova notificação recebida:", data);

          if (data.chat_room_id) {
            console.log(`📨 [CHAT NOTIFICATIONS] Processando notificação do chat room ${data.chat_room_id}: ${data.chat_room_title}`);
            this.highlightChatRoom(data.chat_room_id, data.chat_room_title || `Chat ${data.chat_room_id}`);
          } else {
            console.warn("⚠️ [CHAT NOTIFICATIONS] Notificação recebida sem chat_room_id:", data);
          }
        },

        /**
         * Destaca um chat room com indicador de nova mensagem
         * Só funciona se o chat room já existe na lista do usuário
         */
        highlightChatRoom(chatRoomId, chatRoomTitle) {
          console.log(`🔔 [CHAT NOTIFICATIONS] Destacando chat room: ${chatRoomTitle} (ID: ${chatRoomId})`);

          // Aguarda um pouco para garantir que o DOM foi atualizado
          setTimeout(() => {
            const chatRoomItem = document.querySelector(`.chat_room_item[data-id='${chatRoomId}']`);

            if (!chatRoomItem) {
              console.warn(`⚠️ [CHAT NOTIFICATIONS] Chat room ${chatRoomId} não encontrado - usuário não tem acesso`);
              // Lista todos os chat rooms disponíveis para debug
              const allChatRooms = document.querySelectorAll('.chat_room_item');
              console.log(`🔍 [CHAT NOTIFICATIONS] Chat rooms acessíveis:`, Array.from(allChatRooms).map(item => ({
                id: item.dataset.id,
                title: item.dataset.title
              })));
              // NÃO cria elemento - se não está na lista, usuário não tem acesso
              return;
            }

            console.log(`🎯 [CHAT NOTIFICATIONS] Chat room encontrado no DOM: ${chatRoomTitle}`);

            // Não destaca se for o chat room ativo
            if (chatRoomItem.classList.contains('is-active')) {
              console.log(`👁️ [CHAT NOTIFICATIONS] Chat room ${chatRoomTitle} está ativo, não adicionando indicador`);
              return;
            }

            // Adiciona classe de atualização
            chatRoomItem.classList.add('has-updates');
            console.log(`✅ [CHAT NOTIFICATIONS] Classe 'has-updates' adicionada ao chat ${chatRoomTitle}`);

            // Adiciona indicador visual se ainda não existe
            if (!chatRoomItem.querySelector('.notification-indicator')) {
              const indicator = document.createElement('div');
              indicator.className = 'notification-indicator';

              // Procura pela div de ação existente - NÃO cria se não existir
              const actionDiv = chatRoomItem.querySelector('.item__action');
              if (actionDiv) {
                actionDiv.appendChild(indicator);
                console.log(`🔔 [CHAT NOTIFICATIONS] Indicador visual adicionado para ${chatRoomTitle} (ID: ${chatRoomId})`);
              } else {
                console.warn(`⚠️ [CHAT NOTIFICATIONS] Div .item__action não encontrada para chat ${chatRoomId} - layout inesperado`);
              }
            } else {
              console.log(`ℹ️ [CHAT NOTIFICATIONS] Indicador já existe para ${chatRoomTitle}`);
            }
          }, 100);
        },

        /**
         * Remove indicadores visuais e notifica o servidor que o chat foi visto
         */
        markChatRoomAsSeen(chatRoomId) {
          if (!chatRoomId) {
            console.warn("⚠️ [CHAT NOTIFICATIONS] ID do chat room não fornecido para marcar como visto");
            return;
          }

          console.log(`👁️ [CHAT NOTIFICATIONS] Marcando chat room ${chatRoomId} como visto`);

          // Remove indicadores visuais imediatamente
          const chatRoomItem = document.querySelector(`.chat_room_item[data-id='${chatRoomId}']`);
          if (chatRoomItem) {
            chatRoomItem.classList.remove('has-updates');
            const indicator = chatRoomItem.querySelector('.notification-indicator');
            if (indicator) {
              indicator.remove();
              console.log(`✅ [CHAT NOTIFICATIONS] Indicador removido do chat ${chatRoomId}`);
            }
          }

          // Notifica o servidor via ActionCable
          this.perform('mark_as_seen', { chat_room_id: parseInt(chatRoomId) });
          console.log(`📡 [CHAT NOTIFICATIONS] Comando mark_as_seen enviado para chat ${chatRoomId}`);
        }
      }
    );

    // Função global helper para marcar chats como vistos
    window.markChatRoomAsSeen = function(chatRoomId) {
      console.log(`🔧 [CHAT NOTIFICATIONS] markChatRoomAsSeen chamado para chat ${chatRoomId}`);
      if (window.App && window.App.chatNotifications) {
        window.App.chatNotifications.markChatRoomAsSeen(chatRoomId);
      } else {
        console.error("❌ [CHAT NOTIFICATIONS] Canal não está ativo para marcar como visto");
      }
    };

    console.log("✅ [CHAT NOTIFICATIONS] Sistema configurado e pronto para receber notificações");
    console.log(`✅ [CHAT NOTIFICATIONS] Canal: ${channelName}`);

  } catch (error) {
    console.error("❌ [CHAT NOTIFICATIONS] Erro fatal ao inicializar:", error);
  }
}
